import Link from "../Link";

const CSharp = () => {
    return (
        <div>
            <Link url="https://campus.open-bootcamp.com/cursos/17" title={"OpenBootcamp C#"} />
        </div>
    );
}

export default CSharp;